import Segment from '../shared/segment';
import LessonGroupTable from './lesson-group-table';
import CoefficientTable from './coefficient-table';
import ReferenceLink from './reference-link';
import EduSubGroupsTitle from './title';

function EduSubGroups() {
  return (
    <Segment className='justify-text leading-8'>
      <EduSubGroupsTitle />
      <div className='my-10 mx-auto w-full sm:w-5/6 lg:w-3/5'>
        <LessonGroupTable />
        <CoefficientTable />
      </div>
      <div className='my-10 text-center'>
        <ReferenceLink />
      </div>
    </Segment>
  );
}

export default EduSubGroups;
